import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useJsonLd, getSiteUrl } from "@/hooks/useJsonLd";

export default function ArticleVsPandabuy() {
  const navigate = useNavigate();
  const siteUrl = getSiteUrl();
  useEffect(() => { window.scrollTo(0, 0); document.title = "Kakobuy vs Pandabuy – Który Agent Jest Lepszy? | Kakobuy Spreadsheet"; }, []);

  useJsonLd({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Kakobuy vs Pandabuy – Który Agent Zakupowy Jest Lepszy?",
    "description": "Porównanie dwóch popularnych agentów zakupowych z Chin. Kakobuy Spreadsheet czy Pandabuy? Sprawdź ceny, produkty i opinie.",
    "url": `${siteUrl}/artykul/kakobuy-vs-pandabuy`,
    "datePublished": "2026-06-21",
    "dateModified": "2026-06-21",
    "inLanguage": "pl",
    "author": {
      "@type": "Organization",
      "name": "Kakobuy Spreadsheet Polska",
      "url": siteUrl,
    },
    "publisher": {
      "@type": "Organization",
      "name": "Kakobuy Spreadsheet Polska",
      "url": siteUrl,
    },
    "image": "https://readdy.ai/api/search-image?query=Split%20comparison%20with%20two%20shopping%20carts%20on%20light%20dusty%20rose%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20versus%20competition%20theme%2C%20minimal%20balanced%20composition&width=1600&height=900&seq=kako-art-08-hero&orientation=landscape",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${siteUrl}/artykul/kakobuy-vs-pandabuy`,
    },
  });

  return (
    <>
      <Navbar />
      <main>
        <section className="relative min-h-[55vh] flex flex-col overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url(https://readdy.ai/api/search-image?query=Split%20comparison%20with%20two%20shopping%20carts%20on%20light%20dusty%20rose%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20versus%20competition%20theme%2C%20minimal%20balanced%20composition&width=1600&height=900&seq=kako-art-08-hero&orientation=landscape)" }}></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>
          <div className="relative z-10 flex-1 flex items-center pt-24 pb-12">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <span className="inline-block px-4 py-1.5 bg-background-50/60 backdrop-blur-md rounded-full text-xs font-semibold text-foreground-800 mb-6 whitespace-nowrap">Blog &gt; Porównanie</span>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">Kakobuy vs Pandabuy</h1>
              <p className="text-base text-background-50/85 mt-4 max-w-2xl">Porównanie dwóch popularnych agentów zakupowych. Kakobuy Spreadsheet czy Pandabuy? Sprawdź ceny, produkty i opinie.</p>
            </div>
          </div>
        </section>

        <article className="py-16 md:py-24 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="prose prose-lg max-w-none">
              <section className="mb-14">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">Porównanie: <span className="italic text-foreground-600 font-normal">Kakobuy vs Pandabuy</span></h2>
                <div className="overflow-x-auto mb-6">
                  <table className="w-full border-collapse rounded-xl overflow-hidden">
                    <thead><tr className="bg-foreground-900"><th className="p-4 text-left text-sm font-semibold text-background-50">Cecha</th><th className="p-4 text-left text-sm font-semibold text-background-50">Kakobuy</th><th className="p-4 text-left text-sm font-semibold text-background-50">Pandabuy</th></tr></thead>
                    <tbody>
                      <tr className="border-b border-background-200"><td className="p-4 text-sm font-medium text-foreground-800">Ceny produktów</td><td className="p-4 text-sm text-accent-700 font-semibold">Bardzo niskie</td><td className="p-4 text-sm text-foreground-600">Niskie</td></tr>
                      <tr className="border-b border-background-200 bg-background-50"><td className="p-4 text-sm font-medium text-foreground-800">Wybór produktów</td><td className="p-4 text-sm text-accent-700 font-semibold">Bardzo duży</td><td className="p-4 text-sm text-foreground-600">Duży</td></tr>
                      <tr className="border-b border-background-200"><td className="p-4 text-sm font-medium text-foreground-800">Dostawa do Polski</td><td className="p-4 text-sm text-accent-700 font-semibold">Tak (10-20 dni)</td><td className="p-4 text-sm text-foreground-600">Tak (12-25 dni)</td></tr>
                      <tr className="border-b border-background-200 bg-background-50"><td className="p-4 text-sm font-medium text-foreground-800">Arkusz/Spreadsheet</td><td className="p-4 text-sm text-accent-700 font-semibold">Tak — darmowy</td><td className="p-4 text-sm text-foreground-600">Nie zawsze</td></tr>
                      <tr><td className="p-4 text-sm font-medium text-foreground-800">Obsługa klienta</td><td className="p-4 text-sm text-accent-700 font-semibold">Bardzo dobra</td><td className="p-4 text-sm text-foreground-600">Dobra</td></tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-foreground-700 leading-relaxed mb-4"><strong>Kakobuy Spreadsheet</strong> wypada lepiej w większości kategorii — oferuje niższe ceny, większy wybór produktów i darmowy arkusz z gotowymi linkami. Pandabuy również jest solidną platformą, ale Kakobuy ma przewagę szczególnie dla polskich użytkowników.</p>
              </section>

              <section className="text-center py-10">
                <p className="text-lg text-foreground-700 mb-6">Wybierz <strong>Kakobuy Spreadsheet</strong> — lepszy wybór dla Polaków.</p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="bg-foreground-900 text-background-50 px-7 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">Sprawdź Kakobuy Spreadsheet</a>
                  <a href="/" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/"); }}><i className="ri-arrow-left-line mr-1"></i>Strona główna</a>
                </div>
              </section>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}